import addHandler from "../../../../services/events-handlers";
import { apiFetch } from "../../../../services/api-fetch";

/* bounce rate */
let statTime = 60 * 1000;
    
let isReadUp = false;
let isTime = false;

let checkReadUp = function(content) {
  let bottom = content.getBoundingClientRect().bottom;
  return bottom < window.innerHeight;
};

let sendStat = function(action, postId) {
  let data = new FormData();
  data.append('postId', postId);
 
  apiFetch(action, {
    method: 'POST',
    body: data
  }).catch(function(err) { console.error(err); });
}


export default (content, action, postId) => {
  let timer = setTimeout(function() {
    clearTimeout(timer);
    isTime = true;
    if (isReadUp) sendStat(action, postId);
  }, statTime);

  addHandler('scroll', function(e, stop) {
    if (checkReadUp(content)) {
      stop();
      isReadUp = true;
      if (isTime) sendStat(action, postId);
    }
  });
}